import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { useTranslation } from "react-i18next";
import GenericButton from "@/components/forms/inputs/button/genericButton";
import styles from "@/components/lms/lmsMarketing.module.css";

interface Props {
  onBookNow: () => void;
}

export default function LmsMarketingBanner({ onBookNow }: Props) {
  const { t } = useTranslation();

  return (
    <section className={styles.marketingBanner}>
      <div className={styles.marketingBannerCopy}>
        <span className={styles.marketingEyebrow}>
          <AutoAwesomeOutlinedIcon aria-hidden />
          {t("lms_marketing_banner_eyebrow")}
        </span>
        <h2>{t("lms_marketing_banner_title")}</h2>
        <p>{t("lms_marketing_banner_description")}</p>
      </div>
      <GenericButton
        color="white"
        size="large"
        startIcon={<ShoppingCartOutlinedIcon />}
        onClick={onBookNow}
        className={styles.marketingBannerButton}
        data-testid="lms-marketing-book-now-banner-button"
      >
        {t("lms_marketing_book_now")}
      </GenericButton>
    </section>
  );
}
